import styled from 'styled-components';

import { Box } from 'components/Box';
import { cssBreakpoints, gutterWidth } from 'theme/theme';

const flexPropertyMap = {
  end: 'flex-end',
  start: 'flex-start',
};

export const StyledGridItem = styled(Box)<{
  columnStart?: Array<number>;
  columnEnd?: Array<number>;
  justifySelf?: string;
  alignSelf?: string;
  order?: number;
}>`
  grid-column-start: 1;
  -ms-grid-column: 1;
  grid-column-end: 13;
  -ms-grid-column-span: 12;
  ${({
    columnStart = [1, 1, 1, 1],
    columnEnd = [13, 13, 13, 13],
    justifySelf = 'stretch',
    alignSelf = 'start',
    order = 'auto',
  }) => `
    display: flex;
    width: 100%;
    padding: 0 20px;
    justify-content: ${
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      flexPropertyMap[justifySelf] || justifySelf
    };
    align-items: ${
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      flexPropertyMap[alignSelf] || alignSelf
    };
    flex-wrap: wrap;
    > * {
      width: 100%;
      flex: 0 0 auto;
    }
    @supports (grid-column-gap: ${gutterWidth}px) {
      display: block;
      width: auto;
      padding: 0;
      justify-self: ${justifySelf};
      align-self: ${alignSelf};
    }
    order: ${order};
    @media all and (min-width: ${cssBreakpoints.xsUp}) {
      grid-column-start: ${columnStart[0]};
      grid-column-end: ${columnEnd[0]};
    }
    @media all and (min-width: ${cssBreakpoints.smUp}) {
      grid-column-start: ${columnStart[1]};
      grid-column-end: ${columnEnd[1]};
    }
    @media all and (min-width: ${cssBreakpoints.mdUp}) {
      grid-column-start: ${columnStart[2]};
      grid-column-end: ${columnEnd[2]};
    }
    @media all and (min-width: ${cssBreakpoints.lgUp}) {
      grid-column-start: ${columnStart[3]};
      grid-column-end: ${columnEnd[3]};
    }
  `}
`;
